import { Button, Text } from "@gravity-ui/uikit";
import { Link } from "react-router-dom";
import { useGravityDevice } from "src/hooks/useGravityDevice.ts";
import { T } from "src/i18n";
import { RoutesPaths } from "src/routes/RoutesPaths.ts";
import { Header } from "src/widgets";
import { DocsBlock } from "src/widgets/DocsBlock/DocsBlock.tsx";

import { useLandingPageLinks } from "../hooks/useLandingPageLinks.tsx";
import css from "./landingPageHeader.module.scss";

export const LandingPageHeader = () => {
  const landingPageLinks = useLandingPageLinks();
  const { isMobile } = useGravityDevice();
  return (
    <Header
      links={landingPageLinks}
      actions={
        <>
          {!isMobile && <DocsBlock />}
          <Link to={RoutesPaths.LK.BASE_PATH}>
            <Button size="xl" view="action" className={css.button}>
              <Text variant="subheader-1">
                <T
                  keyName="landing_page.header.login_button"
                  defaultValue="Начать работать"
                />
              </Text>
            </Button>
          </Link>
        </>
      }
    />
  );
};
